import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import qs from 'qs';

import type { IFacilityGroup } from '@model/facilityGroup';

import { apiClient } from '@services/apiClient';

interface IFacilityGroupsKeys {
  search?: string;
}

interface IResponse {
  data: Array<IFacilityGroup>;
  allFacilitiesIdsByGroups: Array<number>;
}

export const facilityGroupsKey = (keys?: IFacilityGroupsKeys): [string, string] => [
  'facilityGroups',
  keys?.search || '',
];
export const facilityGroupsFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof facilityGroupsKey>>) => {
  const params = {
    search: queryKey[1] || undefined,
  };

  return apiClient.get(`${APP_API_URL_V2}fsd/facility-location-group/list`, {
    params,
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });
};

const facilityGroupsSelect = ({ data }: AxiosResponse<IResponse>) => {
  return data || {};
};

export const useFacilityGroupsQuery = (keys?: IFacilityGroupsKeys) => {
  return useQuery({
    // @ts-ignore TODO: update react-query to v5
    queryKey: facilityGroupsKey(keys),
    queryFn: facilityGroupsFn,
    select: facilityGroupsSelect,
  });
};
